import { render, staticRenderFns } from "./CandidateHeader.vue?vue&type=template&id=fe16d034&scoped=true&"
import script from "./CandidateHeader.vue?vue&type=script&lang=js&"
export * from "./CandidateHeader.vue?vue&type=script&lang=js&"
import style0 from "./CandidateHeader.vue?vue&type=style&index=0&id=fe16d034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe16d034",
  null
  
)

/* custom blocks */
import block0 from "./CandidateHeader.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateHeader.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VMenu,VRow})
